import React, { Component } from 'react';
import { connect } from 'react-redux';
import PdfButton from '../Components/PdfButton';
import { add, remove } from '../Actions/Pdf.action';
import { calculateStickyColumnPositions } from '../Events/variantSelector';

class PdfButtonContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            active: this.props.active
        };
    }

    render() {
        return (
            <PdfButton {...this.props}
                onClick={(articleNumber) => this.onClick({ articleNumber })} active={this.state.active} />
        );
    }

    onClick ({ articleNumber }) {
        this.toggleActive()
        this.props.onClick({ articleNumber }, this.state.active)
    }

    toggleActive () {
        this.setState({ active: !this.state.active })
    }
}

const mapStateToProps = state => {
    return {}
}

const mapDispatchToProps = dispatch => {
    return {
        onClick: (data, active) => {
            const articleNumber = data.articleNumber
            if (active) {
                dispatch(remove(articleNumber));
            } else {
                dispatch(add(articleNumber));
            }
        },
        recalcWidth: calculateStickyColumnPositions,
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PdfButtonContainer);